module.exports = __webpack_public_path__ + "static/surgical_mask-c77ca90f20eb475a915cd5fdb4d09efb.png";